import script from "./PrepayList.vue?vue&type=script&lang=ts&setup=true&name=InvoiceList"
export * from "./PrepayList.vue?vue&type=script&lang=ts&setup=true&name=InvoiceList"

const __exports__ = script;

export default __exports__